document.addEventListener('DOMContentLoaded', function() {
    const toggleButton = document.querySelector('.js-toggle-mobile-nav');
    const mobileNav = document.querySelector('.header-mobile-nav');
    const body = document.querySelector('body');

    if ( toggleButton && mobileNav ) {
        toggleButton.addEventListener('click', function() {
            toggleButton?.classList.toggle('is-active');
            mobileNav?.classList.toggle('is-active');
            body?.classList.toggle('no-scroll');
        });
    }
});

window.addEventListener('resize', function() {
    const body = document.querySelector('body');

    if ( body && window.innerWidth > 992 ) {
        body?.classList.remove('no-scroll');
    }
});